import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import {
  alpha,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';

import { PurchaseExtensionOnboardingDemo } from './PurchaseExtensionOnboardingDemo';

interface PurchaseOnboardingModalProps {
  open: boolean;
  onClose: () => void;
  /** Called when user finishes the tour (defaults to onClose). */
  onComplete?: () => void;
}

export const PurchaseOnboardingModal = ({
  open,
  onClose,
  onComplete,
}: PurchaseOnboardingModalProps) => {
  const theme = useTheme();

  const handleDone = () => {
    (onComplete ?? onClose)();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          background: theme.palette.mainColors.background,
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.text.primary, 0.2)}`,
          // MUI's 32px margins leave a phone ~260px of dialog.
          m: { xs: 1.5, sm: 4 },
          width: { xs: 'calc(100% - 24px)', sm: undefined },
          maxHeight: { xs: 'calc(100% - 24px)', sm: 'calc(100% - 64px)' },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
          <InfoIcon
            sx={{ color: theme.palette.text.primary, mr: 1, flexShrink: 0 }}
          />
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{ fontSize: { xs: '1.05rem', sm: '1.25rem' }, lineHeight: 1.3 }}
          >
            Welcome — shop with the extension
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" aria-label="Close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1, px: { xs: 2, sm: 3 } }}>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.primary' }}>
          You&apos;re in <strong>Purchase mode</strong>. Browse listings
          anywhere, pick the details you want in our Chrome extension, and they
          flow into Unbeatable Loans — where you get loan estimates and submit
          offers.
        </Typography>

        <PurchaseExtensionOnboardingDemo />
      </DialogContent>

      <DialogActions sx={{ px: { xs: 2, sm: 3 }, pb: 2 }}>
        <Button
          onClick={handleDone}
          variant="contained"
          color="primary"
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          Got it — start shopping
        </Button>
      </DialogActions>
    </Dialog>
  );
};
